import { render } from "./OwnerNav.vue?vue&type=template&id=315e1c2c&scoped=true"
import script from "./OwnerNav.vue?vue&type=script&lang=js"
export * from "./OwnerNav.vue?vue&type=script&lang=js"

import "./OwnerNav.vue?vue&type=style&index=0&id=315e1c2c&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315e1c2c"]])

export default __exports__